import { Panel } from 'primereact/panel';

const RenderizarQuestionario = ({ questionario, stateQuestionario, tituloEtapa, renderActions, etapa, campoQuestionarioTexto}) => {

    if (questionario && stateQuestionario !== undefined) {
        let content = (<div dangerouslySetInnerHTML={{ __html: campoQuestionarioTexto }} />);
        return (
            <div className="questionario-etapa-prepos">
                <Panel header={tituloEtapa}>
                    {content}
                    {renderActions(etapa)}
                </Panel>
            </div>
        )
    }
}

export default RenderizarQuestionario